import { render, staticRenderFns } from "./DialogFormDepartment.vue?vue&type=template&id=6658dd10"
import script from "./DialogFormDepartment.vue?vue&type=script&lang=js"
export * from "./DialogFormDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports